
<div *ngIf="pedido.permiteAgendamento(pedido.entrega.formaDeEntrega, empresa.formasDeEntrega)">
  <div class="text-muted font-12 mt-2" *ngIf="!apenasAgendamento && exigeAgendamentoPelosItens()">
    <i class="fas fa-calendar-alt mr-1"></i>Sua sacola tem item que só sai agendado: escolha o dia e o horário.
  </div>
  <div class="form-group mb-0 escolher " *ngIf="!apenasAgendamento && !exigeAgendamentoPelosItens()">
    <label class="mt-2 k-checkbox-label"  >
      <input type="checkbox" id="agendarEntrega" name="agendarEntrega" class="k-checkbox " kendoCheckBox   [(ngModel)]="agendarEntrega"
      (ngModelChange)="clicouAgendarEntrega()" />
      Quero agendar {{getLabel()}}

    </label>
  </div>
  <div class="form-group mt-2" *ngIf="agendarEntrega">
    <label>Data   {{getLabel()}}: </label><br>
    <kendo-datepicker #dataEntrega='ngModel' [(ngModel)]="pedido.dataEntrega" [min]="diaMiminio" [max]="dataMaximaAgendamento"
                      class="form-control data_entrega mr-2 k-display-inline-block" id="dataEntrega" format="dd/MM/yy"
                      name="dataEntrega" style="width: 150px"  [disabledDates]="disabledDates"
                      [required]="agendarEntrega" (afterValueChanged)="alterouDataDeEntrega()"   >
      <kendo-datepicker-messages
        today="Hoje"
        toggle="Trocar calendário"
      ></kendo-datepicker-messages>

    </kendo-datepicker>

    <div style="width: 130px;display: inline-flex">
    <kendo-combobox id="horarioEntrega" name="horarioEntrega" [(ngModel)]="horarioAgendado"  [data]="horariosDisponiveis"
                    *ngIf="!pedido.naoInformarHorarioNoAgendamentoSelecionado(empresa.formasDeEntrega)"
                    [required]="agendarEntrega"    [itemDisabled]="itemDisabled" textField="descricao" valueField="valor"
                    [allowCustom]="horariosDisponiveis.length == 0" [clearButton]="false"   placeholder="hh:mm" class="form-control"
                     (selectionChange)="alterouHorarioAgendado($event)"
                    [kendoDropDownFilter]="filterSettings"
                    [readonly]="!pedido.dataEntrega || naoFunciona || naoDaTempo ">
    </kendo-combobox>
    </div>

    <label *ngIf="dataEntrega?.errors?.disabledDate || naoFunciona ||  naoDaTempo" class="mt-2 text-danger">
      <i class="fas fa-exclamation-triangle mr-1"></i>
      <ng-container *ngIf="naoFunciona">Não fazemos agendamento na data selecionada.</ng-container>
      <ng-container *ngIf="naoDaTempo"> Não há tempo hábil para fazermos a entrega na data selecionada.</ng-container>
      <ng-container *ngIf="!naoFunciona && !naoDaTempo">
        O dia <b>{{pedido.dataEntrega | date: 'dd/MMM/yy'}} </b> não está disponivel para agendamento
      </ng-container>
    </label>

  </div>
</div>
